import React from 'react';
import styled from '@emotion/styled';
import { Icon } from '../../../generic-icon/Icon';
import { Icons } from '@model/common/icons';
import { TestId } from '@components/test-ids';
import { ThemeProps } from '@theme/base';
import { ZIndex } from '@styles/z-index';
import { mq } from '@styles/breakpoints';

const CloseButtonContainer = styled.div(({ theme }: ThemeProps) => ({
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: ZIndex.CONTENT,

  [mq.small]: {
    right: theme.custom.spacing.xLarge,
    top: theme.custom.spacing.medium - 1
  }
}));

const CloseButton = styled.button(({ theme }: ThemeProps) => ({
  border: 'none',
  backgroundColor: 'white',
  cursor: 'pointer',
  padding: '15px',
  borderRadius: '0px 0px 0px 10px',

  ['i']: {
    transition: `color ${theme.custom.transitions.default}`
  },

  ['&:hover']: {
    ['i']: {
      color: theme.custom.colors.group1.light
    }
  }
}));

const CloseIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '2.5rem',
  color: theme.custom.colors.group4.light
}));

export interface GalleryCloseButtonProps {
  onDismiss: () => void;
}

export const GalleryCloseButton = ({ onDismiss }: GalleryCloseButtonProps) => {
  return (
    <CloseButtonContainer>
      <CloseButton onClick={onDismiss} data-testid={TestId.imageGallery.closeButton}>
        <CloseIcon name={Icons.CLEAR} />
      </CloseButton>
    </CloseButtonContainer>
  );
};
